<template>
  <div id="markets">
    <div v-for="market in markets" :key="market.id" :value="market.id">
      <h6 style="font-weight: bold">{{ market.name }}</h6>

      <table class="table">
        <tr v-for="book in market.books" :key="book.id" :value="book.id">
          <td>
            {{ book.name }}
            <br />
            {{ book.id }} 
            <br /><span
              v-if="book.removed"
              style="font-weight: bold"
            >
              removed: {{ book.removed }}
            </span>
          </td>
          <td>
            <div
              v-for="outcome in book.outcomes"
              :key="outcome.id"
              :value="outcome.id"
              style="border-bottom: 1px solid #ccc"
            >
              type: {{ outcome.type }} <br />
              <span v-if="outcome.odds_decimal">
                decimal odds: {{ outcome.odds_decimal }} <br/></span>
              <span v-if="outcome.odds_american">
                american odds: {{ outcome.odds_american }} <br/></span>
              <span v-if="outcome.odds_fraction">
                fraction odds: {{ outcome.odds_fraction }} <br/></span>
              <span v-if="outcome.open_odds_decimal">
                open decimal odds: {{ outcome.open_odds_decimal }} <br/></span>
              <span v-if="outcome.open_odds_american">
                open american odds: {{ outcome.open_odds_american }} <br/></span>
              <span v-if="outcome.open_odds_fraction">
                open fraction odds: {{ outcome.open_odds_fraction }} <br/></span>
              <span v-if="outcome.handicap">
                handicap: {{ outcome.handicap }} <br/></span>
              <span v-if="outcome.open_handicap">
                open handicap: {{ outcome.open_handicap }} <br/></span>
              <span v-if="outcome.total">
                total: {{ outcome.total }} <br/></span>
              <span v-if="outcome.open_total">
                open total: {{ outcome.open_total }} <br/></span>
              <span v-if="outcome.removed" style="font-weight: bold">
                removed: {{ outcome.removed }}
              </span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "SportEventMarkets",
  props: {
    markets: "",
  },
  data: function () {
    return {};
  },
  created: function () {},
};
</script>

